import { createUseStyles } from 'react-jss'

import { fileNameMargin } from '../styles'
import { mediumGrey } from '../../../styles/const/colors'

const iconSize = 18
const useStyles = createUseStyles({
  preview: {
    // icon is smaller then image or video preview
    width: ({ hasIcon }) => (hasIcon ? iconSize : 34),
    height: ({ hasIcon }) => (hasIcon ? iconSize : 34),
    objectFit: 'cover',
    marginRight: fileNameMargin,
    borderRadius: 2
  },
  icon: {
    fontSize: iconSize,
    marginRight: fileNameMargin,
    color: ({ iconColor }) => iconColor
  },
  details: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center'
  },
  fileName: {
    wordBreak: 'break-word',
    marginTop: '0 !important',
    marginBottom: '0 !important'
  },
  description: {
    extend: 'fileName',
    fontSize: 14,
    color: mediumGrey
  }
})

export default useStyles
